import React from "react";
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'

const SurveyGrid = observer((props) => {
    //console.log("survey grid", props.hiddenColumns)

    //take hidden columns and evaluate if its needs to be hidden, create a list with just column nums to hide
    
    var hideColumnsX ="";
    if (props.expandableColumns) {
        for (var i = 0; i <= props.expandableColumns.length - 1; i++) {
            hideColumnsX = hideColumnsX + " " + "hideCol" + props.expandableColumns[i];
        }

    } else if (props.expandableColumns) {
        //reformat if it is an expandable grid
        hideColumnsX = " expandableGrid "
    }
    else {
        hideColumnsX = " ";
    }
    const newChildren = React.Children.map(props.children, child => {
        return React.cloneElement(child, { hiddenColumns: props.hiddenColumns, tableName: props.tableName});
    });

    return (
        <table 
            align="left" 
            className={"grid " + props.styleName + hideColumnsX}
            role="table"
        >
            {newChildren}
        </table>
    );
});

export default SurveyGrid;

